<div id="lesson">
  <div class="container-fluid">
    <div class="row">

      <div class="col-md-3">
        <a routerLink="/research/mou"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
        <nav id="secondary-navigation">
          <header class="header">
            <h5>Functional MOUs (2023-24)</h5>
          </header>

          <ul>
            <li class="first"><a (click)="changeRoute('1')">Indian Institute of Comp. Edu</a></li>
            <li class="second"><a (click)="changeRoute('2')">Contrivez</a></li>
            <li class="third"><a (click)="changeRoute('3')">Webcom</a></li>
            <li class="four"><a (click)="changeRoute('4')">Ek Soch Nayi Soch</a></li>
            <li class="five"><a (click)="changeRoute('5')">MOU Udhyam Learning, Ek Soch & GNKC</a></li>
            <li class="six"><a (click)="changeRoute('6')">SMS Khalsa Lanana Girls College</a></li>
            <li class="seven"><a (click)="changeRoute('7')">GNG College, Yamuna Nagar</a></li>
            <li class="eight"><a (click)="changeRoute('8')">Babu Anant Ram Janta College Kaithal</a></li>
            <li class="nine"><a (click)="changeRoute('9')">Functional MOU 2023-24</a></li>
          </ul>
        </nav>
      </div>

      <div class="col-md-9">
        <div class="card shadow-lg">
          <iframe [src]="src | safe" width="100%" height="1100" allow="autoplay" (load)="hideLoader()"></iframe>
        </div>
      </div>

    </div>
  </div>
</div>